// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "238" ? "lpu-staff" : chunkId) + "/" + (chunkId === "238" ? "lpu-staff" : chunkId) + "." + {"119": "0caef5fa9742b4b4","123": "4f5e590b241a76de","238": "045120947d0e7d62","29": "0d13362131a7c806","85": "e2d0fdd3ba580cf8","97": "424aaca49c60869d",}[chunkId] + ".css"
}